import React, { FC } from 'react';
import Rive from '@rive-app/react-canvas';

const GEM_PING_SRC = `${process.env.PUBLIC_URL}/static/rivs/gem-ping.riv`;

const GemPing: FC = () => <Rive src={GEM_PING_SRC} />;

export default GemPing;
